type AgentDetailsMap = Record<string, string>;

export type AgentDetail = {
	name: string;
	link: string;
	src: string;
};

interface Agent {
	id: number;
	image: string;
	name: string;
	strategy: string;
	details: AgentDetail[];
	yield: string;
	apiKey: string;
	contractAddress: string;
	baseURL: string;
	minDeposit: number;
	maxDeposit: number;
	minDepositFormatted: number;
	MODULE_NAME: string;
	usdcAddress: string;
	disabled?: boolean;
	agentDetails: AgentDetailsMap;
}

export const AGENTS_LIST: Agent[] = [
	/*{
		id: 0,
		name: 'Conservative',
		strategy: 'Conservative Strategy',
		details: 'Tapp Exchange',
		yield: '10-15% APY',
		apiKey: 'Wn9Lp5Hd3Jc7Vt2Ur0Po8Ns3Yf8Qm2Zx6Ta4Kb1',
		contractAddress:
			'0x6af230a2cbefcc77e700658ceb0c572f0bc38b3716181d6efab7cd0d0370dcfb',
		baseURL:
			'https://firestore-atlas-api-prod-97381787615.us-central1.run.app',
		minDeposit: 5,
		maxDeposit: 1000,
		minDepositFormatted: 100_000,
		MODULE_NAME: 'custody_vault_multiple',
		usdcAddress:
			'0xbae207659db88bea0cbead6da0ed00aac12edcdda169e591cd41c94180b46f3b',
	},*/

	{
		id: 2,
		name: 'Delta Neutral',
		strategy: 'Hyperion',
		details: [
			{
				name: 'Hyperion',
				link: 'https://hyperion.xyz/pool/0x925660b8618394809f89f8002e2926600c775221f43bf1919782b297a79400d8',
				src: '/hyperion.jpeg',
			},
			{
				name: 'Decibel',
				link: 'https://app.decibel.trade/trade/APT-USD',
				src: '/decibel.jpeg',
			},
		],
		yield: '25%-35% APY',
		apiKey: 'Ry8Te7Yu6Ui5Io4Op3Pa2Sd1Fg0Gh9Jj8Kl7Lz6',
		contractAddress:
			'0xd20ab5f11f12af728f8dd0fd72d393fb64db205e64b989bc2e057e79fe183bbd',
		baseURL:
			'https://firestore-atlas-api-decibel-97381787615.us-central1.run.app',
		minDeposit: 10,
		maxDeposit: 100,
		minDepositFormatted: 100_000,
		MODULE_NAME: 'custody_vault_multiple',
		usdcAddress:
			'0xbae207659db88bea0cbead6da0ed00aac12edcdda169e591cd41c94180b46f3b',
		agentDetails: {
			hyperionUSDCValue: 'hyperion CLMM position',
			merkleUSDCValue: 'merkle Short position',
			totalUSDCValueWithIncentives: 'total USDC with incentives',
			totalUSDCValueWithoutIncentives: 'total USDC (without incentives)',
		},
		image: '/decibel.jpeg',
	},
	/*{
		id: 2,
		name: 'Delta Neutral',
		strategy: 'Hyperion',
		disabled: true,
		details: [
			{
				name: 'Hyperion',
				link: 'https://hyperion.xyz/pool/0x925660b8618394809f89f8002e2926600c775221f43bf1919782b297a79400d8',
			},
			{
				name: '+Decibel',
				link: 'https://app.merkle.trade/trade/APT_USD',
			},
		],
		yield: '45% APY',
		apiKey: 'Ry8Te7Yu6Ui5Io4Op3Pa2Sd1Fg0Gh9Jj8Kl7Lz6',
		contractAddress:
			'0xae468cad15c04397df7919a0fb5870ee5bdb620d83909474ed9259953d5dcb4f',
		baseURL:
			'https://firestore-atlas-dn-api-97381787615.us-central1.run.app',
		minDeposit: 80,
		maxDeposit: 10000,
		minDepositFormatted: 100_000,
		MODULE_NAME: 'custody_vault_multiple',
		usdcAddress:
			'0xbae207659db88bea0cbead6da0ed00aac12edcdda169e591cd41c94180b46f3b',
		agentDetails: {
			hyperionUSDCValue: 'hyperion CLMM position',
			merkleUSDCValue: 'merkle Short position',
			totalUSDCValueWithIncentives: 'total USDC with incentives',
			totalUSDCValueWithoutIncentives: 'total USDC (without incentives)',
		},
		image: '/decibal.png',
	},*/
	{
		image: '/hyperion.png',
		disabled: true,
		id: 1,
		name: 'Conservative',
		strategy: 'Hyperion',
		details: [
			{
				name: 'Hyperion/Tapp',
				src: '/hyperion.jpeg',
				link: 'https://explorer.aptoslabs.com/object/0x886ff50730c73c92f3ab352f80cefb1e3895c86e61b7de40cd3ce93d8c1bb0f5/transactions?network=mainnet',
			},
		],
		yield: '10-15% APY',
		apiKey: 'Ry8Te7Yu6Ui5Io4Op3Pa2Sd1Fg0Gh9Jj8Kl7Lz6',
		contractAddress:
			'0xb029ed986513867ece5af5d16748d66bfb23ba7a15e01a17fe6c851f7b2e39e5',
		baseURL:
			'https://firestore-atlas-api-hyperion-97381787615.us-central1.run.app',
		minDeposit: 5,
		maxDeposit: 10000,
		minDepositFormatted: 100_000,
		MODULE_NAME: 'custody_vault_multiple',
		usdcAddress:
			'0xbae207659db88bea0cbead6da0ed00aac12edcdda169e591cd41c94180b46f3b',
		agentDetails: {
			valueUsdcBase: 'Deposited amount',
			usdtToUsdcBase: 'APT/USDC pool value',
			aptToUsdcBase: 'Short Apt Value',
			totalUnrealizedBase: 'Total unrealised',
		},
	},
];
